const LOCK_KEY = 'otk-notification-tab-lock-v1'
const LOCK_TTL_MS = 15000

const tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`

type LeaderLock = {
  tabId: string
  expiresAt: number
}

const now = (): number => Date.now()

const readLock = (): LeaderLock | null => {
  try {
    const raw = window.localStorage.getItem(LOCK_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as LeaderLock
    if (!parsed?.tabId || typeof parsed.expiresAt !== 'number') return null
    return parsed
  } catch {
    return null
  }
}

const writeLock = (lock: LeaderLock): void => {
  try {
    window.localStorage.setItem(LOCK_KEY, JSON.stringify(lock))
  } catch {
    // ignore
  }
}

const clearOwnLock = (): void => {
  try {
    const current = readLock()
    if (current?.tabId === tabId) {
      window.localStorage.removeItem(LOCK_KEY)
    }
  } catch {
    // ignore
  }
}

// Освобождаем лидерство при закрытии вкладки, чтобы другая вкладка быстрее подхватила уведомления.
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', clearOwnLock)
}

/**
 * Возвращает true только для одной "лидирующей" вкладки.
 * Лидер продлевает lock на каждый вызов; если вкладка умерла, lock истекает по TTL.
 */
export const isNotificationLeaderTab = (): boolean => {
  if (typeof window === 'undefined') return false

  const current = readLock()
  const ts = now()

  if (!current || current.expiresAt <= ts || current.tabId === tabId) {
    writeLock({
      tabId,
      expiresAt: ts + LOCK_TTL_MS,
    })
    return true
  }

  return false
}
